import { render, staticRenderFns } from "./MSPointExchangeSetting.vue?vue&type=template&id=86e31958&"
import script from "./MSPointExchangeSetting.vue?vue&type=script&lang=js&"
export * from "./MSPointExchangeSetting.vue?vue&type=script&lang=js&"
import style0 from "./MSPointExchangeSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports